import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Testimonial în curs de colectare',
  name: 'Nume Client',
  role: 'Ocupație'
}, {
  quote: 'Testimonial în curs de colectare',
  name: 'Nume Client',
  role: 'Ocupație'
}, {
  quote: 'Testimonial în curs de colectare',
  name: 'Nume Client',
  role: 'Ocupație'
}];
export function TestimonialsSection() {
  return <section className="bg-navy diagonal-pattern py-20 px-6" data-id="element-294">
      <div className="max-w-7xl mx-auto" data-id="element-295">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-light font-heading text-4xl md:text-5xl font-bold text-center mb-4" data-id="element-296">
          Ce spun clienții care au lucrat{' '}
          <span className="text-gold" data-id="element-297">cu mine</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-center justify-center gap-2 mb-16" data-id="element-298">
          <div className="flex items-center gap-2 bg-dark-card/60 border border-gold/20 rounded-full px-5 py-2.5" data-id="element-299">
            <svg className="w-4 h-4 text-gold flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-300">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-301"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-302"></path>
            </svg>
            <p className="text-text-light-secondary font-body text-sm" data-id="element-303">
              Din motive de confidențialitate, numele clienților sunt fictive.
              Testimonialele sunt reale și reflectă experiențe autentice.
            </p>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-304">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card rounded-xl p-8 border-t-[3px] border-gold" data-id="element-305">
              <QuoteIcon className="w-10 h-10 text-gold mb-4 opacity-50" strokeWidth={1.5} data-id="element-306" />
              <p className="text-text-light-secondary font-body text-base italic leading-relaxed mb-6" data-id="element-307">
                "{testimonial.quote}"
              </p>
              <div data-id="element-308">
                <p className="text-text-light font-body font-medium" data-id="element-309">
                  {testimonial.name}
                </p>
                <p className="text-text-light-secondary font-body text-sm" data-id="element-310">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}